import React from 'react';
import './spinner.less';

export default () => (
  <div className="spinner-wrapper">
    <div className="spinner" />
  </div>
);
